module.exports = __webpack_public_path__ + "static/img/news22_5.89af32c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/news22_5.jpeg
// module id = Fct1
// module chunks = 0